import { render } from "./LegacyProjectUserPledge.vue?vue&type=template&id=4aed00a5"
import script from "./LegacyProjectUserPledge.vue?vue&type=script&lang=js"
export * from "./LegacyProjectUserPledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__